'use client';

import React from 'react';
import { Navbar as NextUINavbar, NavbarBrand } from "@heroui/navbar";
import { Link } from "@heroui/link";
import Brand from '@/components/Layouts/Default/Brand';
import useAuth from '@/hooks/useAuth';
import NavbarTools from '@/components/Layouts/Default/Partials/Navbar/components/desktop/NavbarTools';
import NavbarLinks from '@/components/Layouts/Default/Partials/Navbar/components/desktop/NavbarLinks';
import NavbarAuth from '@/components/Layouts/Default/Partials/Navbar/components/desktop/NavbarAuth';

const NavbarDesktop = () => {
  const { user } = useAuth();

  return (
    <NextUINavbar
      classNames={{
        base: 'border-b border-gray-medium2',
        wrapper: 'max-w-[300rem] px-5 min-h-[62px] gap-12',
      }}
    >
      <NavbarBrand
        className="!flex-initial hover:opacity-100"
        as={Link}
        href={'/'}
      >
        <Brand />
      </NavbarBrand>
      <NavbarTools />
      <NavbarLinks isAuthenticated={Boolean(user)} />
      <NavbarAuth isAuthenticated={Boolean(user)} />
    </NextUINavbar>
  );
};

export default NavbarDesktop;
